var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1035 11.75L24.5068 14.4863L24.5693 14.9121L24.9688 15.0732C25.5891 15.3223 26.174 15.6517 26.708 16.0537L27.043 16.3057L27.4326 16.1533L30.0977 15.1113L32.1846 18.624L29.9473 20.3262L29.5947 20.5947L29.6592 21.0332C29.754 21.6752 29.754 22.3277 29.6592 22.9697L29.5947 23.4082L29.9473 23.6758L32.1816 25.376L30.0947 28.8877L27.4287 27.8477L27.041 27.6963L26.708 27.9443C26.1702 28.3453 25.5832 28.6768 24.9619 28.9297L24.5645 29.0908L24.5029 29.5156L24.1045 32.2373L21.8594 32.1445L22.001 32.25H19.9033L19.5 29.5127L19.4365 29.0859L19.0361 28.9258L18.8057 28.8291C18.2709 28.5943 17.7654 28.2976 17.2988 27.9453L16.9639 27.6934L16.5732 27.8457L13.9062 28.8867L11.8203 25.375L14.0547 23.6748L14.4072 23.4062L14.3428 22.9678C14.2479 22.3257 14.2479 21.6733 14.3428 21.0312L14.4072 20.5928L14.0547 20.3242L11.8203 18.624L13.9062 15.1113L16.5732 16.1533L16.9609 16.3047L17.2939 16.0566C17.8328 15.6561 18.4205 15.3252 19.042 15.0713L19.4375 14.9092L19.5 14.4863L19.9033 11.75H24.1035ZM13.8184 14.8809H13.8193V14.8945L13.8184 14.8965V14.8809Z",
    stroke: "#172664",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 4.25,
    stroke: "#172664",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSystem);
export default __webpack_public_path__ + "static/media/btn_system.8e5077e5d5f556c20d08d0ccbc6fc039.svg";
export { ForwardRef as ReactComponent };